"use client";

import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

export default function ReceiptBarcode({ value, text = null, className = "", width = 2, height = 80, margin = 8, style = {}, showText = false }) {
  const svgRef = useRef(null);
  useEffect(() => {
    const v = (value ?? "").toString().trim();
    if (!v || !svgRef.current) return;
    try {
      JsBarcode(svgRef.current, v, {
        format: "CODE128",
        displayValue: false,
        width,
        height,
        margin,
        background: "transparent",
      });
    } catch {}
  }, [value, width, height, margin]);

  return (
    <div className={className} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: showText ? 6 : 0, ...style }}>
      <svg ref={svgRef} role="img" aria-label={`Barcode for ${text || value}`} />
      {showText ? (
        <div style={{ fontSize: 14, letterSpacing: 1 }}>{text || value}</div>
      ) : null}
    </div>
  );
}
